import Signup from "../../../../jsx/pages/Agent/Signup";

const SignupWrapper = function (props) {
  return <Signup />;
};

export default constore(SignupWrapper);
